const learnSwiperSlide = require("tpl/index/learn-swiper-slide.html");

const __index = {
    page: 1,
    type: 2,
    pageSize: 8,
    index: 0,
    next: true,
    initBannerSwiper() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.pagination',
            loop: true,
            paginationClickable: true,
            autoplay: 3000
        });
    },
    initLearnWindowtabs() {
        let $tab = $('._learnTabsHead li');
        let tabsSwiper = new Swiper('._learnWindowTabs', {
            speed: 5000,
            direction: 'vertical',
            mode: 'vertical',
            onSlideChangeStart: function () {
                $tab.removeClass('active')
                    .eq(tabsSwiper.activeIndex)
                    .addClass('active');
            }
        });

        $tab
            .off('click.tabs')
            .on('click.tabs', function () {
                let $this = $(this);

                __index.type = $this.data('type');
                __index.page = 1;
                __index.index = $this.index();
                __index.next = true;
                $this
                    .siblings('li').removeClass('active')
                    .end()
                    .addClass('active');

                tabsSwiper.swipeTo(__index.index, 500, __index.getAcadList());
            });
    },
    initBrandSwiper() {
        var mySwiper = new Swiper('._searchBrandList', {
            loop: true,
            autoplay: 5000
        });
    },
    getAcadList() {
        window.util.ajax({
            type: 'get',
            url: '/org/ajaxGetAcadListByType',
            data: {
                page: __index.page,
                pagesize: __index.pageSize,
                type: __index.type
            },
            dataType: 'json',
            callback: function (json) {
                if (json.data.length == 0) {
                    __index.page--;
                    __index.next = false;
                    return false;
                }
                $('._learnSwiper' + (__index.index + 1)).find('.swiper-slide').html(learnSwiperSlide(json));
            }
        });
    },
    leftSild() {
        __index.index = $(this).data('slide');
        if (__index.page == 1) {
            return false;
        }
        __index.next = true;
        __index.page--;
        __index.getAcadList();

    },
    rightSild() {
        if (!__index.next) {
            return false;
        }
        __index.page++;
        __index.getAcadList();
    },
    // 最新成交企业订单滚动
    innovateServiceOrderRolling() {
        let $box = $('._innovateServiceOrder'),
            $li = $box.find('li');

        if ($li.length < 4) {
            return;
        }

        let $ul = $box.find('ul'),
            h = $li.eq(0).outerHeight();


        rolling();

        function rolling() {
            $ul.animate({
                'margin-top': '-' + h
            }, '5000', 'swing', function () {
                let first = $ul.find('li').eq(0),
                    copyLi = first.clone();

                first.remove();
                $ul.append(copyLi)
                    .removeAttr('style');
                setTimeout(rolling, 4000);
            });
        }
    },
    setSlideBtnPos() {
        let slideText = $('._slideText');
        let left = slideText.offset().left,
            winWidth = $('body').width(),
            width = slideText.outerWidth();
        // width多算了一边的pandding。所以减去了就会多减40px。再加上40px

        $('._sliderControler').css('right', winWidth - left - width + 40);
    },
    tipUser() {
        layer.msg('功能开发中,敬请期待');
    },
    init() {
        let [i, j, k, t] = [0, 9, 0, 9];
        const delayTime = 4000;

        this.sliceBannerText();
        this.initBannerSwiper();
        this.initBrandSwiper();
        this.initLearnWindowtabs();
        this.getAcadList();
        this.setSlideBtnPos();
        this.innovateServiceOrderRolling();
        let $domList0 = $('.animationList0 .list-item-block'),
            $domList1 = $('.animationList1 .list-item-block'),
            $domList2 = $('.animationList2 .list-item-block'),
            $domList3 = $('.animationList3 .list-item-block'),
            domList0Len = $domList0.length,
            domList1Len = $domList1.length,
            domList2Len = $domList2.length,
            domList3Len = $domList3.length;

        setInterval(function () {
            let $dom = $domList0.eq(i++);

            if ($dom.hasClass('showInfo')) {
                return false;
            }
            $dom.addClass('animationChange').show().siblings('.list-item-block').hide().removeClass('animationChange');
            // 因为i先加了.所以要获取第一张图。就要在这里让i等于-1
            if (i == domList0Len) {
                i = -1;
            }
        }, delayTime);


        setInterval(function () {
            let $dom = $domList1.eq(j--);

            if ($dom.hasClass('showInfo')) {
                return false;
            }
            $dom.addClass('animationChange').show().siblings('.list-item-block').hide().removeClass('animationChange');
            if (j == 0) {
                j = domList1Len + 1;
            }
        }, delayTime);

        setInterval(function () {
            let $dom = $domList2.eq(k++);

            if ($dom.hasClass('showInfo')) {
                return false;
            }
            $dom.addClass('animationChange').show().siblings('.list-item-block').hide().removeClass('animationChange');
            if (k == domList2Len) {
                k = -1;
            }
        }, delayTime);
        setInterval(function () {
            let $dom = $domList3.eq(t--);

            if ($dom.hasClass('showInfo')) {
                return false;
            }
            $dom.addClass('animationChange').show().siblings('.list-item-block').hide().removeClass('animationChange');
            if (t == 0) {
                t = domList3Len + 1;
            }
        }, delayTime);
        $(window).on('resize', this.setSlideBtnPos);
    },
    // 限制banner上的文字说明最大四行
    sliceBannerText: function () {
        const textList = $('._currSlideContent');
        const maxLimitNum = 146;

        textList.each((index, item) => {
            let msg = $(item).text();

            if (msg.length > maxLimitNum) {
                $(item)
                    .text(msg.slice(0, maxLimitNum) + "...");
            }
        });
    }
};

$(function () {
    __index.init();

    $('.list-item-block').hover(function () {
        $(this).addClass("showInfo");
    }, function () {
        $(this).removeClass("showInfo");
    });

    $(document)
        .on('click', '.learn-arrow-left', __index.leftSild)
        .on('click', '.learn-arrow-right', __index.rightSild)
        .on('click', '._closePop',function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parent(".declare-pop").hide();
        })
    // .on('click', '.showInfo', __index.tipUser);
});